import * as Sentry from '@sentry/react'

export type CwAlarmEvent = {
  type:
    | 'cw_alarm_session_status'
    | 'cw_alarm_discovery_done'
    | 'cw_alarm_item_update'
    | 'cw_alarm_stream'
    | 'ping'
    | 'error'
  session_id?: number
  status?: string
  total_alarms?: number
  fix_created?: number
  not_an_issue?: number
  escalated?: number
  skipped?: number
  failed?: number
  item_id?: number
  step?: string
  result?: string
  content?: string
  tool_name?: string
  tool_input?: string
  tool_result?: string
  detail?: string
  error_message?: string
  [key: string]: unknown
}

export function createCwAlarmSocket(
  onEvent: (event: CwAlarmEvent) => void,
  onClose?: () => void,
) {
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
  const ws = new WebSocket(`${protocol}//${window.location.host}/api/cw-alarm/ws`)

  ws.onmessage = (e) => {
    try {
      const event: CwAlarmEvent = JSON.parse(e.data)
      if (event.type === 'ping') return
      if (event.type === 'error') {
        Sentry.captureMessage(`CwAlarm error: ${event.detail ?? 'Unknown'}`, 'error')
      }
      onEvent(event)
    } catch {
      console.error('Failed to parse CW alarm event:', e.data)
    }
  }

  ws.onclose = () => onClose?.()

  const close = () => ws.close()

  return { close, ws }
}
